export default __webpack_public_path__ + "static/sobbing-f7accb1adb125005940277fe1d529c1e.svg";